import { EntityMigration } from "../../entity/EntityMigration";

export class DtoMigrationsPutRes extends EntityMigration {}
